import { gql } from '@apollo/client';

export const GET_CUSIP_MUNI_INFOS = gql`
  query GetCusipMuniInfos($skip: Int = 0, $take: Int = 1000, $positionIds: [String!]!) {
    cusipMuniInfos(skip: $skip, take: $take, positionIds: $positionIds) {
      recordId
      positionId
      cusip
      fiscalYear
      security
      type
      isRev
      isGO
      isGOFake
      creditEnhancement
      taxProvision
      maturityType
      issueDate
      maturityDate
      description
      state
      county
      mudYear
      sp
      spRatingDt
      spUnder
      spUnderRatingDt
      moody
      moodyRatingDt
      moodyUnder
      moodyUnderRatingDt
      debtToAssessed
      stateAvgDA
      debtLimit
      daWithOverlapping
      perCapita
      pcWithOverlapping
      rateCovenant
      debtCoverage
      levyCollectionRate
      top3Taxpayers
      intergovernmentalAid
      population
      enrollment
      arcCoveredPayroll
      contrArc
      fundedRatio
      nplAssets
      nplCoveredPayroll
      arcCoveredPayroll2
      nolAssets
      nolCoveredPayroll
      pobsAssets
      fsTurnover
      govFundRevenues
      govFundExpenses
      endingNetAssets
      changeInNetAssets
      unrealGenFundBal
      genFundBal
      netRevenue
      grossDirectDebt
      pledgedRevenue
      directDebtNet
      debtService
      taxAssessed
      averageDebtService
      marketValue
      maxDebtService
      taxLevies
      ltdTaxLeviesCollected
      taxCollections
      goDebtService
      overlappingDebt
      updatedDate
    }
  }
`;
